<template>
    <svg width="76" height="71" viewBox="0 0 76 71" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M60.6409 14.5H4.85907C2.58969 14.5 0.75 16.0235 0.75 17.9028V64.0972C0.75 65.9765 2.58969 67.5 4.85907 67.5H60.6409C62.9103 67.5 64.75 65.9765 64.75 64.0972V17.9028C64.75 16.0235 62.9103 14.5 60.6409 14.5Z"
            fill="#E5EBFF"
        />
        <path
            d="M64.3032 5.81836H8.8359C6.57932 5.81836 4.75 7.64768 4.75 9.90426V65.3716C4.75 67.6282 6.57932 69.4575 8.8359 69.4575H64.3032C66.5598 69.4575 68.3891 67.6282 68.3891 65.3716V9.90426C68.3891 7.64768 66.5598 5.81836 64.3032 5.81836Z"
            stroke="#525252"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M4.75 14H68.25" stroke="#525252" stroke-width="1.3" />
        <path
            d="M21.75 29.3719C21.75 28.3381 20.6307 27.5 19.25 27.5C17.8693 27.5 16.75 28.3381 16.75 29.3719V57.6281C16.75 58.6619 17.8693 59.5 19.25 59.5C20.6307 59.5 21.75 58.6619 21.75 57.6281V29.3719Z"
            fill="#8C9FF8"
        />
        <path
            d="M32.75 17.3791C32.75 16.3413 31.6307 15.5 30.25 15.5C28.8693 15.5 27.75 16.3413 27.75 17.3791V57.6209C27.75 58.6587 28.8693 59.5 30.25 59.5C31.6307 59.5 32.75 58.6587 32.75 57.6209V17.3791Z"
            fill="#8C9FF8"
        />
        <path
            d="M44.75 33.4222C44.75 32.3606 43.6307 31.5 42.25 31.5C40.8693 31.5 39.75 32.3606 39.75 33.4222V57.5778C39.75 58.6394 40.8693 59.5 42.25 59.5C43.6307 59.5 44.75 58.6394 44.75 57.5778V33.4222Z"
            fill="#8C9FF8"
        />
        <path
            d="M56.75 21.415C56.75 20.3574 55.6307 19.5 54.25 19.5C52.8693 19.5 51.75 20.3574 51.75 21.415V57.585C51.75 58.6426 52.8693 59.5 54.25 59.5C55.6307 59.5 56.75 58.6426 56.75 57.585V21.415Z"
            fill="#8C9FF8"
        />
        <path
            d="M11.1504 48.1081L29.9785 29.0532C32.66 26.3415 37.0022 26.2255 39.8223 28.7885L41.5158 30.3284C44.6408 33.1711 49.5199 32.7679 52.1408 29.4539L70.1121 6.71191"
            stroke="#525252"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M71.8811 7.26613C73.4734 7.26613 74.7642 5.97534 74.7642 4.38307C74.7642 2.79079 73.4734 1.5 71.8811 1.5C70.2888 1.5 68.998 2.79079 68.998 4.38307C68.998 5.97534 70.2888 7.26613 71.8811 7.26613Z"
            fill="white"
            stroke="#525252"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.69557 53.5894C10.2878 53.5894 11.5786 52.2986 11.5786 50.7063C11.5786 49.114 10.2878 47.8232 8.69557 47.8232C7.10329 47.8232 5.8125 49.114 5.8125 50.7063C5.8125 52.2986 7.10329 53.5894 8.69557 53.5894Z"
            fill="white"
            stroke="#525252"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
